import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_travel" }, { title: "menu_sidebar_health_orders", link: "/travel/orders" }];

const TravelOrderListing = Loadable({
  loader: () => import("container/travel/order/listing"),
  loading() {
    return <Loader />;
  }
});

const TravelOrder = Loadable({
  loader: () => import("container/travel/order"),
  loading() {
    return <Loader />;
  }
});

export const travelOrderRoutes: IRoute[] = [
  {
    path: "/travel/orders",
    element: <TravelOrderListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/travel/orders/details/:id?",
    element: <TravelOrder />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
